// src/lib/sample-data/payments.ts
import type { Payment } from '@/lib/types';

// Simple format for dashboard display
export const sampleRecentPayments = [
  { id: 'pay_1', description: 'Tennis Court Booking - Morning Session', date: '2024-12-22', amount: 'CHF 35.00' },
  { id: 'pay_2', description: 'Padel Court Booking - Evening Match', date: '2024-12-20', amount: 'CHF 30.00' },
  { id: 'pay_3', description: 'Tennis Court Booking - Weekend Training', date: '2024-12-16', amount: 'CHF 40.00' },
  { id: 'pay_4', description: 'Clay Court Practice Session', date: '2024-12-13', amount: 'CHF 38.00' },
  { id: 'pay_5', description: 'Padel Doubles Session', date: '2024-12-09', amount: 'CHF 32.00' },
  { id: 'pay_6', description: 'Monthly Premium Membership', date: '2024-12-02', amount: 'CHF 120.00' },
  
  // John McEnroe (Admin) - Global Padel Group Payments
  {
    id: '1001234583',
    userUid: '4567891230', // John McEnroe
    subscriptionId: '4001234567890', // Global Padel Premium Membership
    amount: 95.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Global Padel Premium Membership - Monthly',
    date: '2024-12-01',
    invoiceNumber: 'INV-PADEL-2024-001',
    transactionId: 'txn_padel_1234567890',
    clubId: '7384629150', // Global Padel Club
    billingAccountId: 'acct_global_padel_ch',
    dateCreated: '2024-12-01 12:00:00',
    dateUpdated: '2024-12-01 12:00:00',
    organizationId: '2951738460',
    tenantId: '2951738460',
  },
  {
    id: '1001234584',
    userUid: '4567891230', // John McEnroe
    subscriptionId: '4001234567890',
    amount: 48.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Padel Court Booking - Professional Match',
    date: '2024-12-19',
    invoiceNumber: 'INV-PADEL-2024-002',
    transactionId: 'txn_padel_booking_001',
    clubId: '7384629150', // Global Padel Club
    billingAccountId: 'acct_global_padel_ch',
    dateCreated: '2024-12-19 16:00:00',
    dateUpdated: '2024-12-19 16:00:00',
    organizationId: '2951738460',
    tenantId: '2951738460',
  },
  {
    id: '1001234585',
    userUid: '4567891230', // John McEnroe
    subscriptionId: '4001234567890',
    amount: 120.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Padel Academy Training Package',
    date: '2024-12-05',
    invoiceNumber: 'INV-PADEL-2024-003',
    transactionId: 'txn_padel_training_001',
    clubId: '7384629150', // Global Padel Club
    billingAccountId: 'acct_global_padel_ch',
    dateCreated: '2024-12-05 10:30:00',
    dateUpdated: '2024-12-05 10:30:00',
    organizationId: '2951738460',
    tenantId: '2951738460',
  },
  
  // Venus Williams (Admin) - Urban Tennis Centers Payments
  {
    id: '1001234586',
    userUid: '5678912340', // Venus Williams
    subscriptionId: '5001234567890', // Urban Tennis Elite Membership
    amount: 150.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Urban Tennis Elite Membership - Monthly',
    date: '2024-12-01',
    invoiceNumber: 'INV-URBAN-2024-001',
    transactionId: 'txn_urban_1234567890',
    clubId: '4629385170', // Elite Tennis Academy
    billingAccountId: 'acct_urban_tennis_ch',
    dateCreated: '2024-12-01 14:00:00',
    dateUpdated: '2024-12-01 14:00:00',
    organizationId: '6174829350',
    tenantId: '6174829350',
  },
  {
    id: '1001234587',
    userUid: '5678912340', // Venus Williams
    subscriptionId: '5001234567890',
    amount: 75.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Elite Tennis Court Booking - Championship Training',
    date: '2024-12-14',
    invoiceNumber: 'INV-URBAN-2024-002',
    transactionId: 'txn_urban_booking_001',
    clubId: '4629385170', // Elite Tennis Academy
    billingAccountId: 'acct_urban_tennis_ch',
    dateCreated: '2024-12-14 09:00:00',
    dateUpdated: '2024-12-14 09:00:00',
    organizationId: '6174829350',
    tenantId: '6174829350',
  },
  {
    id: '1001234588',
    userUid: '5678912340', // Venus Williams
    subscriptionId: '5001234567890',
    amount: 200.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Multi-Club Access Pass - Urban Network',
    date: '2024-11-28',
    invoiceNumber: 'INV-URBAN-2024-003',
    transactionId: 'txn_urban_multiclub_001',
    clubId: '4629385170', // Elite Tennis Academy
    billingAccountId: 'acct_urban_tennis_ch',
    dateCreated: '2024-11-28 13:30:00',
    dateUpdated: '2024-11-28 13:30:00',
    organizationId: '6174829350',
    tenantId: '6174829350',
  },
  
  // Amélie Mauresmo (Admin) - Lagardère Paris Racing Payments
  {
    id: '1001234589',
    userUid: '6789123450', // Amélie Mauresmo
    subscriptionId: '6001234567890', // Paris Racing Premium Membership
    amount: 180.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Paris Racing Premium Membership - Monthly',
    date: '2024-12-01',
    invoiceNumber: 'INV-PARIS-2024-001',
    transactionId: 'txn_paris_1234567890',
    clubId: '1928374650', // Paris Racing
    billingAccountId: 'acct_paris_racing_ch',
    dateCreated: '2024-12-01 11:00:00',
    dateUpdated: '2024-12-01 11:00:00',
    organizationId: '9516274830',
    tenantId: '9516274830',
  },
  {
    id: '1001234590',
    userUid: '6789123450', // Amélie Mauresmo
    subscriptionId: '6001234567890',
    amount: 65.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Clay Court Booking - Professional Training',
    date: '2024-12-17',
    invoiceNumber: 'INV-PARIS-2024-002',
    transactionId: 'txn_paris_booking_001',
    clubId: '1928374650', // Paris Racing
    billingAccountId: 'acct_paris_racing_ch',
    dateCreated: '2024-12-17 15:45:00',
    dateUpdated: '2024-12-17 15:45:00',
    organizationId: '9516274830',
    tenantId: '9516274830',
  },
  {
    id: '1001234591',
    userUid: '6789123450', // Amélie Mauresmo
    subscriptionId: '6001234567890',
    amount: 350.00,
    currencyCode: 'CHF',
    status: 'Pending',
    description: 'Multi-Sport Complex Annual Package',
    date: '2024-12-20',
    invoiceNumber: 'INV-PARIS-2024-003',
    transactionId: 'txn_paris_annual_001',
    clubId: '3748591620', // Multi-Sport Complex
    billingAccountId: 'acct_paris_racing_ch',
    dateCreated: '2024-12-20 10:00:00',
    dateUpdated: '2024-12-20 10:00:00',
    organizationId: '9516274830',
    tenantId: '9516274830',
  },
];

// New structured payment data linked to users and subscriptions
export const samplePaymentsData: Payment[] = [
  // User Flow: Payments go to club through user's billing account
  // Note: Super Admin users should not have sample payment data in production
  
  // Club Flow: Payments go directly to club's billing account
  {
    id: '1001234568',
    userUid: '2847391650', // Roger Federer
    subscriptionId: '2001234567890', // Topspin Club Basic Membership
    amount: 60.00,
    currency: 'CHF',
    currencyCode: 'CHF',
    method: 'Other',
    provider: 'stripe',
    status: 'Paid',
    description: 'Topspin Club Basic Membership - Monthly',
    date: '2024-12-01',
    invoiceNumber: 'INV-CLUB-2024-001',
    transactionId: 'txn_club_1234567891',
    clubId: '5847293610', // Topspin Tennis Club (receives payment)
    billingAccountId: 'acct_topspin_tennis_ch', // Club's billing account (like bank account)
    dateCreated: '2024-12-01 14:30:00',
    dateUpdated: '2024-12-01 14:30:00',
    organizationId: '8392746510',
    tenantId: '8392746510',
  },
  {
    id: '1001234569',
    userUid: '6182947350', // Andy Murray
    subscriptionId: '2001234567890', // Topspin Club Basic Membership
    amount: 60.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Topspin Club Basic Membership - Monthly',
    date: '2024-12-01',
    invoiceNumber: 'INV-CLUB-2024-002',
    transactionId: 'txn_club_1234567892',
    clubId: '5847293610', // Topspin Tennis Club (receives payment)
    billingAccountId: 'acct_topspin_tennis_ch', // Club's billing account (like bank account)
    dateCreated: '2024-12-01 09:15:00',
    dateUpdated: '2024-12-01 09:15:00',
    organizationId: '8392746510',
    tenantId: '8392746510',
  },
  {
    id: '1001234570',
    userUid: '3948572610', // Jannik Sinner
    subscriptionId: '3001234567890', // Topspin 10-Hour Booking Pass
    amount: 180.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Topspin 10-Hour Booking Pass',
    date: '2024-11-15',
    invoiceNumber: 'INV-CLUB-2024-003',
    transactionId: 'txn_club_1234567893',
    clubId: '5847293610', // Topspin Tennis Club (receives payment)
    billingAccountId: 'acct_topspin_tennis_ch', // Club's billing account (like bank account)
    dateCreated: '2024-11-15 16:45:00',
    dateUpdated: '2024-11-15 16:45:00',
    organizationId: '8392746510',
    tenantId: '8392746510',
  },
  {
    id: '1001234571',
    userUid: '5729384610', // Coco Gauff
    subscriptionId: '5001234567890', // Alpine Sports Club Membership
    amount: 75.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Alpine Sports Club Membership - Monthly',
    date: '2024-12-01',
    invoiceNumber: 'INV-CLUB-2024-004',
    transactionId: 'txn_club_1234567894',
    clubId: '6473820195', // Alpine Sports Center (receives payment)
    billingAccountId: 'acct_alpine_sports_ch', // Club's billing account (like bank account)
    dateCreated: '2024-12-01 11:20:00',
    dateUpdated: '2024-12-01 11:20:00',
    organizationId: '8392746510',
    tenantId: '8392746510',
  },
  
  // Recent booking payments (club-based billing)
  {
    id: '1001234572',
    userUid: '2847391650', // Roger Federer
    subscriptionId: '2001234567890',
    amount: 35.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Tennis Court Booking - Morning Session',
    date: '2024-12-22',
    invoiceNumber: 'INV-CLUB-2024-101',
    transactionId: 'txn_club_booking_001',
    clubId: '5847293610', // Topspin Tennis Club
    billingAccountId: 'acct_topspin_tennis_ch', // Club billing ID
    dateCreated: '2024-12-22 09:00:00',
    dateUpdated: '2024-12-22 09:00:00',
    organizationId: '8392746510',
    tenantId: '8392746510',
  },
  {
    id: '1001234573',
    userUid: '2847391650', // Roger Federer
    subscriptionId: '2001234567890',
    amount: 30.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Padel Court Booking - Evening Match',
    date: '2024-12-20',
    invoiceNumber: 'INV-CLUB-2024-102',
    transactionId: 'txn_club_booking_002',
    clubId: '5847293610', // Topspin Tennis Club
    billingAccountId: 'acct_topspin_tennis_ch', // Club billing ID
    dateCreated: '2024-12-20 18:00:00',
    dateUpdated: '2024-12-20 18:00:00',
    organizationId: '8392746510',
    tenantId: '8392746510',
  },
  {
    id: '1001234574',
    userUid: '6182947350', // Andy Murray
    subscriptionId: '2001234567890',
    amount: 40.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Tennis Court Booking - Weekend Training',
    date: '2024-12-16',
    invoiceNumber: 'INV-CLUB-2024-103',
    transactionId: 'txn_club_booking_003',
    clubId: '5847293610', // Topspin Tennis Club
    billingAccountId: 'acct_topspin_tennis_ch', // Club billing ID
    dateCreated: '2024-12-16 14:00:00',
    dateUpdated: '2024-12-16 14:00:00',
    organizationId: '8392746510',
    tenantId: '8392746510',
  },
  {
    id: '1001234575',
    userUid: '3948572610', // Jannik Sinner
    subscriptionId: '3001234567890',
    amount: 38.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Clay Court Practice Session',
    date: '2024-12-13',
    invoiceNumber: 'INV-CLUB-2024-104',
    transactionId: 'txn_club_booking_004',
    clubId: '5847293610', // Topspin Tennis Club
    billingAccountId: 'acct_topspin_tennis_ch', // Club billing ID
    dateCreated: '2024-12-13 10:00:00',
    dateUpdated: '2024-12-13 10:00:00',
    organizationId: '8392746510',
    tenantId: '8392746510',
  },
  {
    id: '1001234576',
    userUid: '5729384610', // Coco Gauff
    subscriptionId: '5001234567890',
    amount: 32.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Padel Doubles Session',
    date: '2024-12-09',
    invoiceNumber: 'INV-CLUB-2024-105',
    transactionId: 'txn_club_booking_005',
    clubId: '6473820195', // Alpine Sports Center
    billingAccountId: 'acct_alpine_sports_ch', // Club billing ID
    dateCreated: '2024-12-09 16:30:00',
    dateUpdated: '2024-12-09 16:30:00',
    organizationId: '8392746510',
    tenantId: '8392746510',
  },
  {
    id: '1001234577',
    userUid: '2847391650', // Roger Federer
    subscriptionId: '2001234567890',
    amount: 120.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Monthly Premium Court Access',
    date: '2024-12-02',
    invoiceNumber: 'INV-CLUB-2024-106',
    transactionId: 'txn_club_premium_001',
    clubId: '5847293610', // Topspin Tennis Club
    billingAccountId: 'acct_topspin_tennis_ch', // Club billing ID
    dateCreated: '2024-12-02 11:20:00',
    dateUpdated: '2024-12-02 11:20:00',
    organizationId: '8392746510',
    tenantId: '8392746510',
  },
  
  // Maria Sharapova (Teacher) - Payment records
  {
    id: '1001234578',
    userUid: '4051728396', // Maria Sharapova
    subscriptionId: '2001234567890', // Topspin Club Basic Membership
    amount: 60.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Topspin Club Basic Membership - Monthly',
    date: '2024-12-01',
    invoiceNumber: 'INV-CLUB-2024-107',
    transactionId: 'txn_club_1234567895',
    clubId: '5847293610', // Topspin Tennis Club
    billingAccountId: 'acct_topspin_tennis_ch', // Club billing ID
    dateCreated: '2024-12-01 15:45:00',
    dateUpdated: '2024-12-01 15:45:00',
    organizationId: '8392746510',
    tenantId: '8392746510',
  },
  {
    id: '1001234579',
    userUid: '4051728396', // Maria Sharapova
    subscriptionId: '2001234567890',
    amount: 42.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Tennis Coaching Session - Advanced Training',
    date: '2024-12-18',
    invoiceNumber: 'INV-CLUB-2024-108',
    transactionId: 'txn_club_coaching_001',
    clubId: '5847293610', // Topspin Tennis Club
    billingAccountId: 'acct_topspin_tennis_ch', // Club billing ID
    dateCreated: '2024-12-18 10:30:00',
    dateUpdated: '2024-12-18 10:30:00',
    organizationId: '8392746510',
    tenantId: '8392746510',
  },
  {
    id: '1001234580',
    userUid: '4051728396', // Maria Sharapova
    subscriptionId: '2001234567890',
    amount: 28.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Court Equipment Rental - Professional Rackets',
    date: '2024-12-15',
    invoiceNumber: 'INV-CLUB-2024-109',
    transactionId: 'txn_club_equipment_001',
    clubId: '5847293610', // Topspin Tennis Club
    billingAccountId: 'acct_topspin_tennis_ch', // Club billing ID
    dateCreated: '2024-12-15 14:15:00',
    dateUpdated: '2024-12-15 14:15:00',
    organizationId: '8392746510',
    tenantId: '8392746510',
  },
  {
    id: '1001234581',
    userUid: '4051728396', // Maria Sharapova
    subscriptionId: '2001234567890',
    amount: 85.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Private Tennis Lesson - Teacher Training Course',
    date: '2024-12-10',
    invoiceNumber: 'INV-CLUB-2024-110',
    transactionId: 'txn_club_lesson_001',
    clubId: '5847293610', // Topspin Tennis Club
    billingAccountId: 'acct_topspin_tennis_ch', // Club billing ID
    dateCreated: '2024-12-10 09:00:00',
    dateUpdated: '2024-12-10 09:00:00',
    organizationId: '8392746510',
    tenantId: '8392746510',
  },
  {
    id: '1001234582',
    userUid: '4051728396', // Maria Sharapova
    subscriptionId: '2001234567890',
    amount: 25.00,
    currencyCode: 'CHF',
    status: 'Pending',
    description: 'Tennis Court Booking - Morning Practice',
    date: '2024-12-23',
    invoiceNumber: 'INV-CLUB-2024-111',
    transactionId: 'txn_club_booking_006',
    clubId: '5847293610', // Topspin Tennis Club
    billingAccountId: 'acct_topspin_tennis_ch', // Club billing ID
    dateCreated: '2024-12-23 08:00:00',
    dateUpdated: '2024-12-23 08:00:00',
    organizationId: '8392746510',
    tenantId: '8392746510',
  },
  
  // John McEnroe (Admin) - Global Padel Group Payments
  {
    id: '1001234583',
    userUid: '4567891230', // John McEnroe
    subscriptionId: '4001234567890', // Global Padel Premium Membership
    amount: 95.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Global Padel Premium Membership - Monthly',
    date: '2024-12-01',
    invoiceNumber: 'INV-PADEL-2024-001',
    transactionId: 'txn_padel_1234567890',
    clubId: '7384629150', // Global Padel Club
    billingAccountId: 'acct_global_padel_ch',
    dateCreated: '2024-12-01 12:00:00',
    dateUpdated: '2024-12-01 12:00:00',
    organizationId: '2951738460',
    tenantId: '2951738460',
  },
  {
    id: '1001234584',
    userUid: '4567891230', // John McEnroe
    subscriptionId: '4001234567890',
    amount: 48.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Padel Court Booking - Professional Match',
    date: '2024-12-19',
    invoiceNumber: 'INV-PADEL-2024-002',
    transactionId: 'txn_padel_booking_001',
    clubId: '7384629150', // Global Padel Club
    billingAccountId: 'acct_global_padel_ch',
    dateCreated: '2024-12-19 16:00:00',
    dateUpdated: '2024-12-19 16:00:00',
    organizationId: '2951738460',
    tenantId: '2951738460',
  },
  {
    id: '1001234585',
    userUid: '4567891230', // John McEnroe
    subscriptionId: '4001234567890',
    amount: 120.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Padel Academy Training Package',
    date: '2024-12-05',
    invoiceNumber: 'INV-PADEL-2024-003',
    transactionId: 'txn_padel_training_001',
    clubId: '7384629150', // Global Padel Club
    billingAccountId: 'acct_global_padel_ch',
    dateCreated: '2024-12-05 10:30:00',
    dateUpdated: '2024-12-05 10:30:00',
    organizationId: '2951738460',
    tenantId: '2951738460',
  },
  
  // Venus Williams (Admin) - Urban Tennis Centers Payments
  {
    id: '1001234586',
    userUid: '5678912340', // Venus Williams
    subscriptionId: '5001234567890', // Urban Tennis Elite Membership
    amount: 150.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Urban Tennis Elite Membership - Monthly',
    date: '2024-12-01',
    invoiceNumber: 'INV-URBAN-2024-001',
    transactionId: 'txn_urban_1234567890',
    clubId: '4629385170', // Elite Tennis Academy
    billingAccountId: 'acct_urban_tennis_ch',
    dateCreated: '2024-12-01 14:00:00',
    dateUpdated: '2024-12-01 14:00:00',
    organizationId: '6174829350',
    tenantId: '6174829350',
  },
  {
    id: '1001234587',
    userUid: '5678912340', // Venus Williams
    subscriptionId: '5001234567890',
    amount: 75.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Elite Tennis Court Booking - Championship Training',
    date: '2024-12-14',
    invoiceNumber: 'INV-URBAN-2024-002',
    transactionId: 'txn_urban_booking_001',
    clubId: '4629385170', // Elite Tennis Academy
    billingAccountId: 'acct_urban_tennis_ch',
    dateCreated: '2024-12-14 09:00:00',
    dateUpdated: '2024-12-14 09:00:00',
    organizationId: '6174829350',
    tenantId: '6174829350',
  },
  {
    id: '1001234588',
    userUid: '5678912340', // Venus Williams
    subscriptionId: '5001234567890',
    amount: 200.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Multi-Club Access Pass - Urban Network',
    date: '2024-11-28',
    invoiceNumber: 'INV-URBAN-2024-003',
    transactionId: 'txn_urban_multiclub_001',
    clubId: '4629385170', // Elite Tennis Academy
    billingAccountId: 'acct_urban_tennis_ch',
    dateCreated: '2024-11-28 13:30:00',
    dateUpdated: '2024-11-28 13:30:00',
    organizationId: '6174829350',
    tenantId: '6174829350',
  },
  
  // Amélie Mauresmo (Admin) - Lagardère Paris Racing Payments
  {
    id: '1001234589',
    userUid: '6789123450', // Amélie Mauresmo
    subscriptionId: '6001234567890', // Paris Racing Premium Membership
    amount: 180.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Paris Racing Premium Membership - Monthly',
    date: '2024-12-01',
    invoiceNumber: 'INV-PARIS-2024-001',
    transactionId: 'txn_paris_1234567890',
    clubId: '1928374650', // Paris Racing
    billingAccountId: 'acct_paris_racing_ch',
    dateCreated: '2024-12-01 11:00:00',
    dateUpdated: '2024-12-01 11:00:00',
    organizationId: '9516274830',
    tenantId: '9516274830',
  },
  {
    id: '1001234590',
    userUid: '6789123450', // Amélie Mauresmo
    subscriptionId: '6001234567890',
    amount: 65.00,
    currencyCode: 'CHF',
    status: 'Paid',
    description: 'Clay Court Booking - Professional Training',
    date: '2024-12-17',
    invoiceNumber: 'INV-PARIS-2024-002',
    transactionId: 'txn_paris_booking_001',
    clubId: '1928374650', // Paris Racing
    billingAccountId: 'acct_paris_racing_ch',
    dateCreated: '2024-12-17 15:45:00',
    dateUpdated: '2024-12-17 15:45:00',
    organizationId: '9516274830',
    tenantId: '9516274830',
  },
  {
    id: '1001234591',
    userUid: '6789123450', // Amélie Mauresmo
    subscriptionId: '6001234567890',
    amount: 350.00,
    currencyCode: 'CHF',
    status: 'Pending',
    description: 'Multi-Sport Complex Annual Package',
    date: '2024-12-20',
    invoiceNumber: 'INV-PARIS-2024-003',
    transactionId: 'txn_paris_annual_001',
    clubId: '3748591620', // Multi-Sport Complex
    billingAccountId: 'acct_paris_racing_ch',
    dateCreated: '2024-12-20 10:00:00',
    dateUpdated: '2024-12-20 10:00:00',
    organizationId: '9516274830',
    tenantId: '9516274830',
  },
];
